import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

//Actions
import * as systemLogActions from '../actions/systemLogActions';

class UsersLog extends React.Component {
    constructor(props) {
		super(props);
    }

    componentDidMount() {
        this.props.actions.getDailyUsersLog();
    }

    render() {
        let { systemlogs, user } = this.props,
        { activeUsers, loggedInUsers } = systemlogs.users,
        { isLoggedIn, isSuperUser, isAdmin } = user;

        if (!(isLoggedIn && isSuperUser)) return false;

        return (
            <div>
                { activeUsers && activeUsers.length ?
                    <div className='usersLogSection'>
                        <h1>Active users</h1>
                        <table className="systemlog">
                            <thead>
                                <tr className='systemlog-row'>
                                    <th className='systemlog-row-id w10'>User ID</th>
                                    <th className='systemlog-row-time w20'>Name</th>
                                    <th className='systemlog-row-time w20'>Email</th>                                    
                                    <th className='systemlog-row-text w20'>Session started at</th>
                                    <th className='systemlog-row-text w10'>'View as' session</th>
                                    <th className='systemlog-row-time w20'>Last active</th>
                                </tr>
                            </thead>
                            <tbody>
                                { activeUsers.map((item, i) =>
                                    <tr className='systemlog-row' key={'actusr_'+item.id}>
                                        <td className='systemlog-row-id w10'>{item.id}</td>
                                        <td className='systemlog-row-text w20'>{item.name}</td>
                                        <td className='systemlog-row-text w20'>{item.email}</td>                                        
                                        <td className='systemlog-row-text w20'>{item.login_time}</td>
                                        <td className='systemlog-row-text w10'>{item.is_view_as ? 'Yes' : 'No'}</td>
                                        <td className='systemlog-row-time w20'>{item.token_time_stamp}</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                : ''}
                { loggedInUsers && loggedInUsers.length ?
                    <div className='usersLogSection'>
                        <h1>LOGGED IN USERS TODAY</h1>
                        <table className="systemlog">
                            <thead>
                                <tr className='systemlog-row'>
                                    <th className='systemlog-row-id w10'>User ID</th>
                                    <th className='systemlog-row-time w20'>Name</th>
                                    <th className='systemlog-row-time w20'>Email</th>
                                    <th className='systemlog-row-text w20'>Session started at</th>
                                    <th className='systemlog-row-text w30'>'View as' session</th>
                                </tr>
                            </thead>
                            <tbody>
                                { loggedInUsers.map((item, i) =>
                                    <tr className='systemlog-row' key={'loggedusr_'+item.id}>
                                        <td className='systemlog-row-id w10'>{item.id}</td>
                                        <td className='systemlog-row-text w20'>{item.name}</td>
                                        <td className='systemlog-row-text w20'>{item.email}</td>
                                        <td className='systemlog-row-text w20'>{item.login_time}</td>
                                        <td className='systemlog-row-text w30'>{item.is_view_as ? 'Yes' : 'No'}</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                : ''}
             </div>
        )

    }
}


export default connect(
    state => ({
        systemlogs: state.systemlogs,
        user: state.user,
    }),
    dispatch => ({
        actions: bindActionCreators({...systemLogActions}, dispatch)
    })
)(UsersLog);



// WEBPACK FOOTER //
// ./source/screens/UsersLog.js